import { useQuery } from "react-query";
import { getUser } from "@/api";
import { getUserId, getRefreshToken } from "@/api/localStorage";
import { useContext } from "react";
import AppContext from "@/App/context/AppContext";

const useUser = () => {
  const userId = getUserId();
  const refreshToken = getRefreshToken();
  const { impersonatorToken: impersonatedBy } = useContext(AppContext);

  return useQuery(["userQuery" + userId], () => getUser(userId), {
    enabled: (!!userId || !!impersonatedBy) && !!refreshToken,
  });
};

export default useUser;
